import { useQuery, useQueryClient } from "@tanstack/react-query";
import client from "../api/sanity_client";

async function getProjectById({ projectId }) {
  const res = await client.fetch(
          `*[_type == "project" && _id == "${projectId}"] {
              _id,
              course,
              title,
              projectSummary,
              video,
              tags,
              students,
              instructors,
              partner,
              mentor,
              semester,
              poster {
                asset-> {
                  _id,
                  url
                }
              },
              previewImage {
                asset-> {
                  _id,
                  url
                }
              },
              affiliation
            }`
        );
  // const res = await fetch(`../api/projects/route/${projectId}/route`);
  // const data = await res.json();
  // console.log("Project data:", res);
  return res[0];
}

export default function useGetProjectById({ projectId }) {
  const queryClient = useQueryClient();
  let projectData;
  const cachedData = queryClient.getQueriesData({ queryKey: ["allProjects"] });

  if (cachedData && cachedData[0]) {
    if (cachedData[0][1]) {
      projectData = cachedData[0][1].find(
        (project) => project._id === projectId
      );
    }
  }

  const { data: project, isLoading: isLoadingProject } = useQuery({
    queryKey: ["singleProjectData", projectId],
    queryFn: projectData
      ? () => projectData
      : () => getProjectById({ projectId }),
  });

  return { project, isLoadingProject };
}
